export default "__VITE_ASSET__NHZDcZTl__"